import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";
import { AppFooter } from "./AppFooter";
import { AppHeader } from "./AppHeader";
import { AppSidebar } from "./AppSidebar";
import { PageContainer } from "./PageContainer";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("tbr-sidebar-collapsed") === "true");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("tbr-sidebar-collapsed", String(collapsed));
  }, [collapsed]);

  return (
    <div className="min-h-screen bg-muted/30">
      <AppSidebar collapsed={collapsed} mobileOpen={mobileOpen} onToggle={() => setCollapsed((value) => !value)} onCloseMobile={() => setMobileOpen(false)} />
      <div className={cn("flex min-h-screen flex-col transition-[margin] duration-200", collapsed ? "lg:ml-[76px]" : "lg:ml-[260px]")}>
        <AppHeader onOpenMobile={() => setMobileOpen(true)} />
        <PageContainer><Outlet /></PageContainer>
        <AppFooter />
      </div>
    </div>
  );
}
